module.exports = __webpack_public_path__ + "static/media/ilustracao_sala_de_aula.ce6e6738.svg";